import { ActionColumnDowload } from './ColumnsFormatters/ActionColumnDowload';
import { ActionColumnDetail } from './ColumnsFormatters/ActionColumnDetail';

export const columnsRecord = (onDownload, onEye, versionAccess) => [
	{
		dataField: 'nombre',
		text: 'Archivo',
		headerAlign: 'left',
	},
	versionAccess === true
		? {
				dataField: 'fecha',
				text: 'Fecha',
				headerAlign: 'left',
		  }
		: {},
	{
		dataField: 'idFile',
		text: 'Descargar Archivo',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnDowload,
		formatExtraData: {
			onDownload,
		},
	},
	versionAccess === true
		? {
				dataField: 'row',
				text: 'Ver Versiones',
				classes: 'text-center',
				headerClasses: 'text-center',
				formatter: ActionColumnDetail,
				formatExtraData: {
					onEye,
				},
		  }
		: {},
];

export const columnsVersions = (onDownload) => [
	{
		dataField: 'versionArchivo',
		text: 'Version',
		headerAlign: 'left',
	},
	{
		dataField: 'nombre',
		text: 'Nombre',
		headerAlign: 'left',
	},
	{
		dataField: 'fecha',
		text: 'Fecha',
		headerAlign: 'left',
	},
	{
		dataField: 'ruta',
		text: 'Descargar documento',
		classes: 'text-center',
		formatter: ActionColumnDowload,
		formatExtraData: {
			onDownload,
		},
	},
];
